import gql from "graphql-tag"

const DELETE_HOME_VIDEO = gql`
  mutation deleteHomeVideo($id: ID!) {
    deleteHomeVideo(id: $id) {
      status
    }
  }
`

export default DELETE_HOME_VIDEO
